module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Assign application ownership"},"da":{"title":"Tildel applikations ejerskab"}}')
  delete Component.options._Ctor
}
